import { ClientsApi } from '@sportheroes/oly-engine-api';

import { olyEngineApi } from './Config/olyEngineApi';

const { CORE_API_URL } = process.env;

export default new ClientsApi(CORE_API_URL, {}, olyEngineApi);
